module.exports = __webpack_public_path__ + "img/icon_credit.b7ac739.svg";